module.exports = __webpack_public_path__ + "static/img/1.ca0232f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/1.png
// module id = VW4A
// module chunks = 0